import { Component, Injectable, OnInit } from '@angular/core';
import { faLinkedinIn, faTwitter, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faMap } from '@fortawesome/free-regular-svg-icons';
import * as $ from 'jquery';

@Component({
    selector: 'juridico-header',
    templateUrl: './header.component.html',
    styleUrls: ['../juridico.component.css']
})
@Injectable()

export class JuridicoHeader implements OnInit {
  linkedin = faLinkedinIn;
  facebook = faFacebookF;
  twitter = faTwitter;
  instagram = faInstagram;

  menuCollapse: boolean;

  constructor(){
    this.menuCollapse = false;
  }

  ngOnInit(): void {
  }

  abrirFecharMenu() {
    if (this.menuCollapse == false) {
      this.menuCollapse = true;
      let element = document.getElementById('navbarSupportedContent');
      if (!element.classList.contains("show"))
        element.classList.add("show");
    } else {
      this.menuCollapse = false;
      let element = document.getElementById('navbarSupportedContent');
      if (element.classList.contains("show"))
        element.classList.remove("show");
    }
  }
}
